<template>
  <v-section
    class="c-section--logo"
    :layout="TileLayout.LOGO"
  >
    <template #default="{ products }">
      <ui-tile
        v-for="product in products"
        :key="product.id"
        :product="product"
        :layout="TileLayout.LOGO"
      ></ui-tile>
    </template>
    <template #headerLeft>
      <slot name="headerLeft"></slot>
    </template>
    <template #headerRight>
      <slot name="headerRight"></slot>
    </template>
  </v-section>
</template>
<script>
  import { TileLayout } from '@/shared/enums';
  import { VSection } from '@/index/shared/components';
  import UiTile from '../../tile/index.vue';

  export default {
    components: {
      UiTile,
      VSection,
    },
    enums: {
      TileLayout,
    },
  };
</script>
